// extracted by mini-css-extract-plugin
export var button = "_ck-4";
export var hasDarkBackground = "_ck-7";
export var hasLightBackground = "_ck-6";
export var iconWrapper = "_ck-0";
export var large = "_ck-2";
export var medium = "_ck-1";
export var small = "_ck-5";
export var xsmall = "_ck-3";